/** When your routing table is too long, you can split it into small modules**/
import Layout from '@/layout';

const optimizeRoutes = {
  component: Layout,
  redirect: {
    name: 'optimize',
  },
  name: 'Optimize',
  alwaysShow: true,
  meta: {
    title: '优化管理',
    permissions: 'optimize',
    icon: 'ali-optimization',
  },
  children: [
    /** 智能创建（融合多媒体版本） */
    {
      component: () => import('@/views/fusion/investment/intelligence-create/index.vue'),
      name: 'FusionIntelligenceCreate',
      meta: { title: '智能创建', permissions: 'fusion-intelligence-create' },
    },
    /** 素材报表 */
    {
      component: () => import('@/views/auxiliary/material-library/material-report/index'),
      name: 'MaterialReport',
      meta: { title: '素材报表', permissions: 'material-report' },
    },
    /** 创建计划日志 */
    {
      component: () => import('@/views/optimize/request-results/index'),
      name: 'RequestResults',
      meta: {
        title: '创建计划日志',
        permissions: 'request-results',
      },
    },
    /** 预警配置 */
    {
      component: () => import('@/views/optimize/monitor-config/index'),
      name: 'MonitorConfig',
      meta: {
        title: '预警配置',
        permissions: 'monitor-config',
      },
    },
    // 投放管理
    {
      component: () => import('@/views/optimize/put-in-manage'),
      name: 'PutInManage',
      meta: { title: '投放管理', permissions: 'put-in-manage' },
      children: [
        {
          component: () => import('@/views/optimize/put-in-manage/campaign-manage'),
          name: 'CampaignManage',
          meta: { title: '广告管理', permissions: 'campaign-manage' },
        },
        {
          component: () => import('@/views/optimize/put-in-manage/creative-manage'),
          name: 'CreativeManage',
          meta: { title: '创意管理', permissions: 'creative-manage' },
        },
      ],
    },
  ],
};

export default optimizeRoutes;
